import { NavBar, Form, Button, Input, DatePicker, Toast } from 'antd-mobile'
import React, { useCallback, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from "moment";
import '../style.css'
import { seasonApi } from '../../../features/season/api/seasonApi';

export default function SeasonInsert() {


    const [buttomLoading, setButtomLoading] = useState(false)

    const navigate = useNavigate()

    const createGamefunc = (values) => {
        setButtomLoading(true)
        const startDate = moment(values.startTime).format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment(values.endTime).format('YYYY-MM-DD HH:mm:ss');
        const formData = new FormData();
        formData.append("startDate", startDate)
        formData.append("endDate", endDate)
        formData.append('name', values.seasonName);
        seasonApi.create(formData)
            .then(function (response) {
                const result = response.data
                if (result.code === 200) {
                    Toast.show({
                        icon: 'success',
                        content: "添加成功！"
                    })
                    // 创建完成后返回已注册的赛季管理路由，避免跳入不存在的页面。
                    navigate("/customSeason")
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: result.msg
                    })
                }

            })
            .catch(function () {
                Toast.show({
                    icon: 'fail',
                    content: "系统错误！请联系管理员",
                })
            })
            .finally(() => {
                setButtomLoading(false)
            });
    }

    const minDate = new Date('2020-01-01');
    const startDatePickerRef = useRef();
    const endDatePickerRef = useRef();

    const handleStartDatePickerClick = () => {
        startDatePickerRef.current?.open();
    };

    const handleEndDatePickerClick = () => {
        endDatePickerRef.current?.open();
    };


    return (
        <div className="custom-season-container season-page season-insert-page has-unified-nav ui-page ui-page--with-nav">
            <NavBar className="unified-navbar fixed" onBack={() => window.history.back()}>
                创建赛季
            </NavBar>
            <div className='body_detail season-body season-insert-body ui-page__content'>
                <section className="season-create-hero">
                    <div>
                        <span>NEW SEASON</span>
                        <strong>创建新的赛季周期</strong>
                        <em>设置赛季名称和起止日期后，球队榜单与赛程数据可以按新赛季归档。</em>
                    </div>
                </section>

                <Form
                    className="season-create-form"
                    name='form'
                    onFinish={(values) => createGamefunc(values)}
                    footer={
                        <Button block className="season-submit-btn" type='submit' color='primary' size='large' loading={buttomLoading}>
                            提交
                        </Button>
                    }
                >
                    <Form.Header>赛季信息</Form.Header>
                    <Form.Item
                        className="season-form-item"
                        name='seasonName'
                        label='赛季名称'
                        rules={[{ required: true, message: '请输入赛季名称' }]}
                    >
                        <Input placeholder='请输入赛季名称' />
                    </Form.Item>
                    <Form.Item
                        className="season-form-item season-date-item"
                        name="startTime"
                        label="开始日期"
                        trigger="onConfirm"
                        onClick={handleStartDatePickerClick}
                        rules={[{ required: true, message: '请选择比赛日期' }]}
                    >
                        <DatePicker
                            min={minDate}
                            ref={startDatePickerRef}
                            precision="day"
                            title="时间选择"
                            renderLabel={useCallback((type, data) => {
                                switch (type) {
                                    case 'year':
                                        return data + '年';
                                    case 'month':
                                        return data + '月';
                                    case 'day':
                                        return data + '日';
                                    default:
                                        return data;
                                }
                            }, [])}
                        >
                            {(value) => (value ? moment(value).format('YYYY-MM-DD') : '请选择日期')}
                        </DatePicker>
                    </Form.Item>

                    <Form.Item
                        className="season-form-item season-date-item"
                        name="endTime"
                        label="结束日期"
                        trigger="onConfirm"
                        onClick={handleEndDatePickerClick}
                        rules={[{ required: true, message: '请选择比赛日期' }]}
                    >
                        <DatePicker
                            min={minDate}
                            ref={endDatePickerRef}
                            precision="day"
                            title="时间选择"
                            renderLabel={useCallback((type, data) => {
                                switch (type) {
                                    case 'year':
                                        return data + '年';
                                    case 'month':
                                        return data + '月';
                                    case 'day':
                                        return data + '日';
                                    default:
                                        return data;
                                }
                            }, [])}
                        >
                            {(value) => (value ? moment(value).format('YYYY-MM-DD') : '请选择日期')}
                        </DatePicker>
                    </Form.Item>
                </Form>
            </div>
        </div >
    )
}
